import { LastModifiedCell } from 'ui/indexPages/tables/cells';
import { GridRow } from 'ui/indexPages/tables/grid';
import { GOALS_GRIDS, MOCK_GOALS } from '../../constants';
import { useGoalAuditUsers } from '../../hooks/useGoalAuditUsers';
import { getUserAuditData } from '../../utils';

export const GoalsTableRows = () => {
  const rows = MOCK_GOALS; // TODO: replace with real data from context
  const { userInfoLookup } = useGoalAuditUsers();

  return (
    <>
      {rows.map((row) => {
        const { createdBy, modifiedBy, createdAt, modifiedAt } = getUserAuditData(
          row,
          userInfoLookup,
        );
        return (
          <GridRow key={row.id} gridLayout={GOALS_GRIDS}>
            <div data-test="goal-name">{row.name}</div>
            <LastModifiedCell
              createdBy={createdBy}
              modifiedBy={modifiedBy}
              createdAt={createdAt}
              modifiedAt={modifiedAt}
            />
          </GridRow>
        );
      })}
    </>
  );
};
